module.exports = __webpack_public_path__ + "static/media/food_4.7bcbf5a7.jpeg";